// import { BaseURL } from "../../lib/api";
// import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
// import { createSlice } from "@reduxjs/toolkit";

// export const admin = createSlice({
//     name: 'Admin',
//     initialState: {
//         isLoading: false,
//     }
// })





// export const adminApi = createApi({
//     reducerPath: 'adminApi',
//     baseQuery: fetchBaseQuery({
//         baseUrl: `${BaseURL}`,
//         prepareHeaders: (headers) => {
//             const currentToken = JSON.parse(localStorage.getItem('token'))
//             if (currentToken) {
//                 headers.set('Authorization', `${currentToken}`)
//             }
//             headers.set('Content-Type', 'application/json')
//             // headers.set('Accept', 'application/json');
//             headers.set('ngrok-skip-browser-warning', true)
//             return headers
//         },
//     }),
//     endpoints: (builder) => ({

//         getUserById: builder.query({
//             query: (id) => `user/get?id=${id}`,
//         }),

//         forgotPassword: builder.mutation({
//             query: (data) => ({
//                 url: `user/forgot-password`,
//                 method: 'POST',
//                 body: data,
//             }),
//         }),

import { BaseURL } from "../../lib/api";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

export const admin = createSlice({
    name: "Admin",
    initialState: {
        isLoading: false,
    },
});

let hasShownTokenError = false;

const baseQuery = fetchBaseQuery({
    baseUrl: `${BaseURL}`,
    prepareHeaders: (headers) => {
        const currentToken = JSON.parse(localStorage.getItem("token"));
        if (currentToken) {
            headers.set("Authorization", `${currentToken}`);
        }
        headers.set("Content-Type", "application/json");
        headers.set("ngrok-skip-browser-warning", true);
        return headers;
    },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    if (result?.error?.status === 401 && !hasShownTokenError) {
        hasShownTokenError = true;

        toast.error("Session expired! Please login again.");

        localStorage.removeItem("token");

        setTimeout(() => {
            window.location.href = "/login";
            hasShownTokenError = false;
        }, 1500);
    }

    return result;
};

export const adminApi = createApi({
    reducerPath: "adminApi",
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getUserById: builder.query({
            query: (id) => `user/get?id=${id}`,
        }),

        forgotPassword: builder.mutation({
            query: (data) => ({
                url: `user/forgot-password`,
                method: "POST",
                body: data,
            }),
        }),



        userRole: builder.query({
            query: ({ offset, limit, isActive, search, type }) => ({
                url: `user/childUser`,
                method: 'GET',
                params: {
                    offset,
                    limit,
                    isActive,
                    search,
                    type,
                },
            }),
            providesTags: ['Users'],
        }),

        createUser: builder.mutation({
            query: (data) => ({
                url: `user/create`,
                method: 'POST',
                body: { ...data },

            }),
            invalidatesTags: ['Users'],
        }),

        updateUser: builder.mutation({
            query: ({ id, data }) => ({
                url: `user/updateUser/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Users'],
        }),

        deleteUser: builder.mutation({
            query: (id) => ({
                url: `user/delete/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Users'],
        }),

        getPermission: builder.query({
            query: ({ offset, limit, isActive, search }) => ({
                url: `permission/get`,
                method: 'GET',
                params: {
                    offset,
                    limit,
                    isActive,
                    search,
                },
            }),
            providesTags: ['Permission'],
        }),

        createpermission: builder.mutation({
            query: (data) => ({
                url: `permission/create`,
                method: 'POST',
                body: { ...data },
            }),
            invalidatesTags: ['Permission'],
        }),

        updatePermission: builder.mutation({
            query: ({ id, payload }) => ({
                url: `permission/update/${id}`,
                method: 'PUT',
                body: payload,
            }),
            invalidatesTags: ['Permission'],
        }),

        deletePermission: builder.mutation({
            query: (id) => ({
                url: `permission/delete/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Permission'],
        }),

        getRole: builder.query({
            query: ({ offset, limit, isActive, search }) => ({
                url: 'role/get',
                method: 'GET',
                params: {
                    offset,
                    limit,
                    isActive,
                    search,
                },
            }),
            providesTags: ['Role'],
        }),

        getUserBasedRoles: builder.query({
            query: () => ({
                url: 'role/userBasedRoles',
                method: 'GET',
            }),
            providesTags: ['Role'],
        }),


        createrole: builder.mutation({
            query: (data) => ({
                url: `role/create`,
                method: 'POST',
                body: { ...data },
            }),
            invalidatesTags: ['Role'],
        }),

        updateRole: builder.mutation({
            query: ({ id, data }) => ({
                url: `role/update/${id}`,
                method: 'PUT',
                body: { ...data },
            }),
            invalidatesTags: ['Role'],
        }),

        deleteRole: builder.mutation({
            query: (id) => ({
                url: `role/delete/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Role'],
        }),

        userType: builder.query({
            query: ({ offset, limit, isActive, search }) => ({
                url: 'userType/get',
                method: 'GET',
                params: {
                    offset,
                    limit,
                    isActive,
                    search,
                },
            }),
            providesTags: ['UserTypes'],
        }),

        createUserType: builder.mutation({
            query: (data) => ({
                url: 'userType/create',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['UserTypes'],
        }),

        deleteUserType: builder.mutation({
            query: (id) => ({
                url: `userType/delete/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['UserTypes'],
        }),

        sendInvite: builder.mutation({
            query: (data) => ({
                url: 'invite/send',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Invites'],
        }),

        getInvites: builder.query({
            query: ({ offset = 0, limit = 10, isAccepted, search = '' }) => ({
                url: 'invite/get',
                method: 'GET',
                params: {
                    offset,
                    limit,
                    ...(isAccepted !== undefined && { isAccepted }),
                    search,
                },
            }),
            providesTags: ['Invites'],
        }),

        getMyInvites: builder.query({
            query: ({ offset = 0, limit = 10, isAccepted, search = '' }) => ({
                url: 'invite/myInvites',
                method: 'GET',
                params: {
                    offset,
                    limit,
                    ...(isAccepted !== undefined && { isAccepted }),
                    search,
                },
            }),
            providesTags: ['MyInvites'],
        }),

        acceptInviteFrom: builder.mutation({
            query: (id) => ({
                url: `invite/accept/${id}`,
                method: 'POST',
            }),
            invalidatesTags: ['MyInvites'],
        }),

        getOrders: builder.query({
            query: ({ offset = 0, limit = 10, status, orderowner, fromDate, toDate }) => {
                const params = { offset, limit };

                if (status) params.status = status;
                if (orderowner) params.orderowner = orderowner;
                if (fromDate) params.fromDate = fromDate;
                if (toDate) params.toDate = toDate;

                return {
                    url: 'order/get',
                    method: 'GET',
                    params,

                };
            },
            providesTags: ['Order'],
        }),

        getMyVendors: builder.query({
            query: () => ({
                url: 'order/myVendors',
                method: 'GET',
            }),
        }),

        getItemsByStore: builder.query({
            query: (storeId) => ({
                url: `item/get/${storeId}`,
                method: 'GET',
            }),
        }),

        createOrder: builder.mutation({
            query: (orderData) => ({
                url: 'order/create',
                method: 'POST',
                body: orderData,
                headers: {
                    authorization: localStorage.getItem('token'),
                },
            }),
            invalidatesTags: ['Order', 'MyOrder', "Billing"],
        }),

        getOrderById: builder.query({
            query: (id) => ({
                url: 'order/get',
                method: 'GET',
                params: { id },
            }),
            providesTags: ['Orderid'],
        }),

        updateOrder: builder.mutation({
            query: ({ id, body }) => ({
                url: `order/updateByStore/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Order'],
        }),

        getItemBags: builder.query({
            query: () => 'itemBag/get',
        }),

        // getItemcat: builder.query({
        //     query: () => 'item/get',
        // }),

        getItemcat: builder.query({
            query: (storeId) => ({
                url: `item/get/${storeId}`, // or ?storeId=${storeId}
                method: 'GET',
            }),
            providesTags: ["ItemCategory"],
        }),


        getMyEmployees: builder.query({
            query: () => 'user/myEmployees',
        }),

        updateOrderItem: builder.mutation({
            query: ({ id, body }) => ({
                url: `order/updateItem/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Orderid', 'MyOrder'],
        }),

        addItemToOrder: builder.mutation({
            query: ({ orderId, body }) => ({
                url: `order/addItem`,
                method: 'POST',
                body: { orderId, ...body },
            }),
            invalidatesTags: ['Orderid', 'MyOrder'],
        }),

        getMyOrders: builder.query({
            query: ({ offset = 0, limit = 10, status, search, fromDate, toDate }) => {
                const params = new URLSearchParams({ offset, limit });
                if (status) params.append('status', status);
                if (search) params.append('search', search);
                if (fromDate) params.append('fromDate', fromDate);
                if (toDate) params.append('toDate', toDate);

                return {
                    url: `order/myOrders`,
                    method: 'GET',
                    params,
                };
            },
            providesTags: ['MyOrder'],
        }),

        getMyOrderById: builder.query({
            query: (id) => ({
                url: `order/myOrders?id=${id}`,
                method: 'GET',

            }),
            providesTags: ['MyOrder'],
        }),


        updateOrderAdmin: builder.mutation({
            query: ({ id, body }) => ({
                url: `order/update/${id}`,
                method: 'PUT',
                body,
                headers: {
                    authorization: localStorage.getItem('token') || '',
                },
            }),
            invalidatesTags: ['MyOrder'],
        }),


        getMyInvoices: builder.query({
            query: ({ offset = 0, limit = 10, status, invoiceStore, search, fromDate, toDate }) => {
                const params = new URLSearchParams({ offset, limit });
                if (status) params.append('status', status);
                if (invoiceStore) params.append('invoiceStore', invoiceStore);
                if (search) params.append('search', search);
                if (fromDate) params.append('fromDate', fromDate);
                if (toDate) params.append('toDate', toDate);

                return {
                    url: `invoice/get`,
                    method: 'GET',
                    params,
                };
            },
            providesTags: ['Invoice'],
        }),



        getMyInvoicesself: builder.query({
            query: ({ offset = 0, limit = 10, status, invoiceStore, fromDate, toDate, search }) => {
                const params = new URLSearchParams();

                params.append('offset', offset.toString());
                params.append('limit', limit.toString());

                if (status) params.append('status', status);
                if (invoiceStore) params.append('invoiceStore', invoiceStore);
                if (fromDate) params.append('fromDate', fromDate);
                if (toDate) params.append('toDate', toDate);
                if (search) params.append('search', search);

                return {
                    url: 'invoice/myInvoices',
                    method: 'GET',
                    params,
                };
            },
            providesTags: ['MyInvoice'],
        }),

        VieGetMyInvoicesself: builder.query({
            query: (id) => ({
                url: `invoice/myInvoices?id=${id}`,
                method: 'GET',
            }),
        }),


        getLogistics: builder.query({
            query: () => ({
                url: 'invoice/getLogistics',
                method: 'GET',
            }),
            providesTags: ['Logistics'],
        }),

        createInvoice: builder.mutation({
            query: (formData) => ({
                url: 'invoice/create',
                method: 'POST',
                body: formData,
            }),
            invalidatesTags: ['Invoice'],
        }),

        getInvoiceById: builder.query({
            query: (id) => ({
                url: `invoice/get?id=${id}`,
                method: 'GET',
            }),
            providesTags: ['Invoice'],
        }),

        getMyInvoiceById: builder.query({
            query: (id) => ({
                url: `invoice/myInvoices?id=${id}`,
                method: 'GET',
            }),
            providesTags: ['Invoice'],
        }),

        assignInvoice: builder.mutation({
            query: ({ invoiceId, assignedTo }) => ({
                url: `invoice/assignInvoice/${invoiceId}`,
                method: 'PUT',
                body: { assignedTo },
            }),
            invalidatesTags: ['Invoice'],
        }),
        cancelInvoice: builder.mutation({
            query: (invoiceId) => ({
                url: `invoice/cancel/${invoiceId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Invoice'],
        }),

        cancelInvoiceMy: builder.mutation({
            query: (invoiceId) => ({
                url: `invoice/cancel/${invoiceId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['MyInvoice'],
        }),

        updateInvoiceStatusByOwner: builder.mutation({
            query: (invoiceId) => ({
                url: `invoice/updateStatusByOwner/${invoiceId}`,
                method: 'PUT',
            }),
            invalidatesTags: ['MyInvoice'],
        }),

        updateLogisticStatus: builder.mutation({
            query: ({ invoiceId, logisticStatus }) => ({
                url: `invoice/updateLogisticStatus/${invoiceId}`,
                method: 'PUT',
                body: { logisticStatus },
            }),
            invalidatesTags: ['Invoice'],
        }),



        updateInvoiceStatusByStore: builder.mutation({
            query: ({ invoiceId, status }) => ({
                url: `invoice/updateStatusByStore/${invoiceId}`,
                method: 'PUT',
                body: { status },
            }),
            invalidatesTags: ['Invoice'],
        }),

        updateOrderStatus: builder.mutation({
            query: ({ orderId, status }) => ({
                url: `order/updateStatus/${orderId}`,
                method: 'PUT',
                params: { orderId },
                body: { status },
            }),
            invalidatesTags: ['Order'],
        }),

        logoutUser: builder.mutation({
            query: () => ({
                url: '/user/logout',
                method: 'POST',
            }),
        }),

        getInventoryItems: builder.query({
            query: ({ fromDate, toDate, category, search, offset, limit }) => {
                const params = new URLSearchParams();

                if (fromDate) params.append('fromDate', fromDate);
                if (toDate) params.append('toDate', toDate);
                if (category) params.append('category', category);
                if (search) params.append('search', search);
                if (offset !== undefined) params.append('offset', offset);
                if (limit !== undefined) params.append('limit', limit);

                return {
                    url: `inventory/getItems?${params.toString()}`,
                    method: 'GET',
                    headers: {
                        authorization: localStorage.getItem('token') || '',
                    },
                };
            },
            providesTags: ['Inventory'],
        }),

        getFarmers: builder.query({
            query: () => ({
                url: 'inventory/farmers',
                method: 'GET',
                headers: {
                    authorization: localStorage.getItem('token') || '',
                },
            }),
            providesTags: ['Farmers'],
        }),

        createInventory: builder.mutation({
            query: (body) => ({
                url: 'inventory/create',
                method: 'POST',
                body,

            }),
            invalidatesTags: ['Inventory', 'Farmers', 'OverallPrice'],
        }),

        updateItemPrice: builder.mutation({
            query: ({ itemId, buyingPrice, sellingPrice }) => ({
                url: `inventory/updatePrice/${itemId}`,
                method: 'PUT',
                body: { buyingPrice, sellingPrice },
            }),
            invalidatesTags: ['Inventory'],
        }),

        getOverallPrices: builder.query({
            query: ({ search }) => ({
                url: 'inventory/getdistict',
                params: { search },
            }),
            providesTags: ['OverallPrice'],
        }),


        updateOverallPrice: builder.mutation({
            query: ({ productName, overallPrice, overrideOption }) => ({
                url: `inventory/overallPrice/${productName}`,
                method: 'PUT',
                body: {
                    overallPrice,
                    overrideOption,
                },
            }),
            invalidatesTags: ['OverallPrice', 'ReceviedBilling', 'ReceviedBillings'],
        }),


        getOverallPricesData: builder.query({
            query: () => ({
                url: 'inventory/getdistict',
            }),
            providesTags: ['OverallPrice'],
        }),

        getBillingItems: builder.query({
            query: ({ productName }) => ({
                url: 'billing/getItems',
                method: 'GET',
                params: { productName },
            }),
            keepUnusedDataFor: 0,
        }),



        getBillingCustomers: builder.query({
            query: () => ({
                url: 'billing/getCustomer',
                method: 'GET',
            }),
            providesTags: ['Billing'],
        }),

        createBilling: builder.mutation({
            query: (billingData) => ({
                url: 'billing/create',
                method: 'POST',
                body: billingData,
            }),
            invalidatesTags: ['Billing'],
        }),

        moveToBilling: builder.mutation({
            query: (body) => ({
                url: 'billing/moveToBilling',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Order'],
        }),

        getReceivedBills: builder.query({
            query: ({ fromDate, toDate, search, paymentMethod, status, offset, limit }) => {
                const params = new URLSearchParams();

                if (fromDate) params.append('fromDate', fromDate);
                if (toDate) params.append('toDate', toDate);
                if (search) params.append('search', search);
                if (paymentMethod) params.append('paymentMethod', paymentMethod);
                if (status) params.append('status', status);
                if (offset !== undefined) params.append('offset', offset);
                if (limit !== undefined) params.append('limit', limit);

                return {
                    url: `billing/getReceivedBills?${params.toString()}`,
                    method: 'GET',
                    headers: {
                        authorization: localStorage.getItem('token') || '',
                    },
                };
            },
            providesTags: ['ReceviedBilling','Billing'],
        }),

        getSingleBilling: builder.query({
            query: (id) => ({
                url: `billing/getReceivedBills?id=${id}`,
                method: 'GET',

            }),
            providesTags: ['ReceviedBillings'],
        }),

        getItemInfo: builder.query({
            query: (id) => `inventory/getItemInfo/${id}`,
        }),

        updateBillingItem: builder.mutation({
            query: ({ id, price }) => ({
                url: `billing/updateItem/${id}`,
                method: 'PUT',
                body: { price },
            }),
            invalidatesTags: ['ReceviedBillings'],
        }),


        updateOverallBill: builder.mutation({
            query: ({ billId, payload }) => ({
                url: `billing/updateOverallBill/${billId}`,
                method: 'PUT',
                body: payload,
            }),
            invalidatesTags: ['ReceviedBillings', 'ReceviedBilling'],
        }),

        getPayableBills: builder.query({
            query: ({ fromDate, toDate, search, paymentMethod, status, offset, limit }) => {
                const params = new URLSearchParams();

                if (fromDate) params.append('fromDate', fromDate);
                if (toDate) params.append('toDate', toDate);
                if (search) params.append('search', search);
                if (paymentMethod) params.append('paymentMethod', paymentMethod);
                if (status) params.append('status', status);
                if (offset !== undefined) params.append('offset', offset);
                if (limit !== undefined) params.append('limit', limit);

                return {
                    url: `billing/getPayableBills?${params.toString()}`,
                    method: 'GET',
                };
            },
            providesTags: ['PayableBilling'],
        }),

        getPayableBill: builder.query({
            query: (id) => `billing/getPayableBills?id=${id}`,
            providesTags: ['PayableBillingId'],
        }),

        calculatePayableBill: builder.mutation({
            query: ({ billId, payload }) => ({
                url: `billing/calculateBill/${billId}`,
                method: "PUT",
                body: payload,
            }),
            invalidatesTags: ['PayableBilling', 'PayableBillingId'],
        }),

        getMyBills: builder.query({
            query: ({ offset = 0, limit = 10, id, paymentStatus, paymentMethod, fromDate, toDate, search }) => {
                const params = new URLSearchParams();

                if (id) params.append("id", id);
                if (paymentStatus) params.append("paymentStatus", paymentStatus);
                if (paymentMethod) params.append("paymentMethod", paymentMethod);
                if (fromDate) params.append("fromDate", fromDate);
                if (toDate) params.append("toDate", toDate);
                if (search) params.append("search", search);

                params.append("offset", offset);
                params.append("limit", limit);

                return {
                    url: `billing/mybills?${params.toString()}`,
                    method: "GET",
                };
            },
        }),

        getMyBillView: builder.query({
            query: (id) => `billing/mybills?id=${id}`,
            providesTags: ['PayableBillingId'],
        }),


        farmerGetMyBills: builder.query({
            query: ({ offset = 0, limit = 10, id, paymentStatus, paymentMethod, fromDate, toDate, search }) => {
                const params = new URLSearchParams();

                if (id) params.append("id", id);
                if (paymentStatus) params.append("paymentStatus", paymentStatus);
                if (paymentMethod) params.append("paymentMethod", paymentMethod);
                if (fromDate) params.append("fromDate", fromDate);
                if (toDate) params.append("toDate", toDate);
                if (search) params.append("search", search);

                params.append("offset", offset);
                params.append("limit", limit);

                return {
                    url: `billing/farmerBills?${params.toString()}`,
                    method: "GET",
                };
            },
        }),

        farmerGetMyBillView: builder.query({
            query: (id) => `billing/farmerBills?id=${id}`,
            providesTags: ['PayableBillingId'],
        }),



        getNotifications: builder.query({
            query: ({ offset = 0, limit = 10 }) => ({
                url: `notification/get?offset=${offset}&limit=${limit}`,
                method: "GET",
                headers: {
                    authorization: localStorage.getItem("token"),
                },
            }),
            transformResponse: (response) => ({
                data: response.data,
                total: response.total,
            }),
            //  keepUnusedDataFor: 0,
        }),

        getNotificationsHeader: builder.query({
            query: () => ({
                url: `notification/get`,
                method: "GET",
                headers: {
                    authorization: localStorage.getItem("token"),
                },
            }),
            transformResponse: (response) => ({
                data: response.data,
                total: response.total,
            }),

        }),


        getUnreadCount: builder.query({
            query: () => ({
                url: `notification/getUnreadCount`,
                method: "GET",
            }),
            transformResponse: (response) => response.unreadCount,
        }),

        // getReports: builder.query({
        //     query: ({ page = 1, limit = 10, paymentStatus, paymentMethod, fromDate, toDate }) => {
        //         const params = new URLSearchParams({
        //             offset: page,
        //             limit,
        //         });

        //         if (paymentStatus) params.append("paymentStatus", paymentStatus);
        //         if (paymentMethod) params.append("paymentMethod", paymentMethod);
        //         if (fromDate) params.append("fromDate", fromDate);
        //         if (toDate) params.append("toDate", toDate);

        //         return {
        //             url: `billing/reports?${params.toString()}`,
        //             method: "GET",
        //         };
        //     },
        //     transformResponse: (response) => ({
        //         data: response.data,
        //         total: response.total,
        //     }),
        // }),

        // getReports: builder.query({
        //     query: ({ page = 1, limit = 10, paymentStatus, paymentMethod, fromDate, toDate, source }) => {
        //         const params = new URLSearchParams({
        //             offset: page,
        //             limit,
        //         });

        //         if (paymentStatus) params.append("paymentStatus", paymentStatus);
        //         if (paymentMethod) params.append("paymentMethod", paymentMethod);
        //         if (fromDate) params.append("fromDate", fromDate);
        //         if (toDate) params.append("toDate", toDate);
        //         if (source) params.append("source", source); // ✅ Added

        //         return {
        //             url: `billing/reports?${params.toString()}`,
        //             method: "GET",
        //         };
        //     },
        //     transformResponse: (response) => ({
        //         data: response.data,
        //         total: response.total,
        //     }),
        // }),


        // ✅ Inside admin slice
        getReports: builder.query({
            query: ({ page = 1, limit = 10, paymentStatus, paymentMethod, fromDate, toDate, source, exportType }) => {
                const params = new URLSearchParams({
                    offset: page,
                    limit,
                });

                if (paymentStatus) params.append("paymentStatus", paymentStatus);
                if (paymentMethod) params.append("paymentMethod", paymentMethod);
                if (fromDate) params.append("fromDate", fromDate);
                if (toDate) params.append("toDate", toDate);
                if (source) params.append("source", source);
                if (exportType) params.append("export", exportType); // ✅ NEW param for export type (e.g. pdf)

                return {
                    url: `billing/reports?${params.toString()}`,
                    method: "GET",
                };
            },
            transformResponse: (response) => ({
                data: response.data,
                total: response.totalRecords || response.total,
            }),
        }),


        getReportsLedger: builder.query({
            query: ({ offset = 1, limit = 10, search = "", minAmount = "", maxAmount = "" }) => {
                const params = new URLSearchParams({
                    offset,
                    limit,
                });

                if (search) params.append("search", search);
                if (minAmount) params.append("minAmount", minAmount);
                if (maxAmount) params.append("maxAmount", maxAmount);

                return {
                    url: `journal/get?${params.toString()}`,
                    method: "GET",

                };
            },
            providesTags: ['getReportsLedgers'],
        }),

        sendCreditsms: builder.mutation({
            query: (data) => ({
                url: `journal/sendCreditsms`,
                method: "POST",
                body: data,
            }),
        }),



        getCustomerJournals: builder.query({
            query: ({ customerId, offset = 1, limit = 10, journalId }) => {
                const params = new URLSearchParams();

                params.append("offset", String(offset));
                params.append("limit", String(limit));

                params.append("ledgerType", "RB");

                if (journalId) params.append("journalId", journalId);

                return {
                    url: `journal/customer/${customerId}?${params.toString()}`,
                    method: "GET",
                };
            },
            providesTags: ["getCustomerJournalss"],
        }),


        createLedgerEntry: builder.mutation({
            query: (body) => ({
                url: "journal/create",
                method: "POST",
                body,
            }),
            invalidatesTags: ['getCustomerJournalss', 'getReportsLedgers'],
        }),


        getReportById: builder.query({
            query: (id) => `billing/reports?id=${id}`,
            transformResponse: (response) => response.data,
        }),

        getPayableLedger: builder.query({
            query: ({ search, fromAmount, toAmount, offset, limit }) => {
                const params = new URLSearchParams();
                if (search) params.append("search", search);
                if (fromAmount) params.append("minAmount", fromAmount);
                if (toAmount) params.append("maxAmount", toAmount);
                if (offset !== undefined) params.append("offset", offset);
                if (limit !== undefined) params.append("limit", limit);

                return {
                    url: `/journal/getPayable?${params.toString()}`,
                    method: "GET",
                };
            },
            transformResponse: (response) => ({
                total: response.total || 0,
                customers: response.customers || [],
            }),
        }),


        getPayableCustomerJournals: builder.query({
            query: ({ customerId, offset = 1, limit = 10, journalId }) => {
                const params = new URLSearchParams();

                params.append("offset", String(offset));
                params.append("limit", String(limit));
                params.append("ledgerType", "PB");

                if (journalId) params.append("journalId", journalId);

                return {
                    url: `journal/customer/${customerId}?${params.toString()}`,
                    method: "GET",
                };
            },
            providesTags: ["PayableLedger"],
        }),

        createPayableLedgerEntry: builder.mutation({
            query: (body) => ({
                url: "journal/createPayable",
                method: "POST",
                body,
            }),
            invalidatesTags: ["PayableLedger"],
        }),

        getDashboard: builder.query({
            query: () => ({
                url: "dashboard/get",
                method: "GET",
            }),
        }),

        getDashboardQueries: builder.query({
            query: ({ offset = 1, limit = 10, search = "" }) => ({
                url: `dashboard/getQueries`,
                method: "GET",
                params: { offset, limit, search },
            }),
            providesTags: ["DashboardQueries"],
        }),

        updateDashboardQueryStatus: builder.mutation({
            query: ({ id, status }) => ({
                url: `dashboard/updateQuery/${id}`,
                method: "PUT",
                body: { status },
            }),
            invalidatesTags: ["DashboardQueries"],
        }),

        getExpenses: builder.query({
            query: ({ search = "", fromDate = "", toDate = "", offset = 0, limit = 10 }) => {
                const params = new URLSearchParams();
                if (search) params.append("search", search);
                if (fromDate) params.append("fromDate", fromDate);
                if (toDate) params.append("toDate", toDate);
                params.append("offset", offset);
                params.append("limit", limit);

                return `expense/get?${params.toString()}`;
            },
            providesTags: ["Expenses"],
        }),

        deleteExpense: builder.mutation({
            query: (id) => ({
                url: `expense/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Expenses"],
        }),

        getBillPdf: builder.query({
            query: (billId) => ({
                url: `billing/print/${billId}`,
                method: "GET",
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    return window.URL.createObjectURL(blob);
                },
            }),
        }),


        getBillPdfPayable: builder.query({
            query: (billId) => ({
                url: `billing/print/payableBill/${billId}`,
                method: "GET",
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    return window.URL.createObjectURL(blob);
                },
            }),
        }),


        getreportBill: builder.query({
            query: (billId) => ({
                url: `billing/print/reportBill/${billId}`,
                method: "GET",
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    return window.URL.createObjectURL(blob);
                },
            }),
        }),


        getOrderPdf: builder.query({
            query: (orderId) => ({
                url: `order/print/${orderId}`,
                method: "GET",
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    return window.URL.createObjectURL(blob);
                },
            }),
        }),

        getinvoicePdf: builder.query({
            query: (orderId) => ({
                url: `invoice/print/${orderId}`,
                method: "GET",
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    return window.URL.createObjectURL(blob);
                },
            }),
        }),

        updateInventoryStock: builder.mutation({
            query: (inventoryId) => ({
                url: `inventory/updateStock/${inventoryId}`,
                method: "PUT",

            }),
            invalidatesTags: ['Inventory'],
        }),

        acceptInvite: builder.mutation({
            query: (token) => ({
                url: "/invite/acceptInvite",
                method: "POST",
                headers: {
                    invitetoken: token,
                },
            }),
        }),

        sendEnquiry: builder.mutation({
            query: (body) => ({
                url: "/dashboard/query",
                method: "POST",
                body,
            }),
        }),

        sendItemCategory: builder.mutation({
            query: (body) => ({
                url: "/item/create",
                method: "POST",
                body,
            }),
            invalidatesTags: ["ItemCategory"],
        }),

        getAllItemCategories: builder.query({
            query: ({ offset = 0, limit = 10, search = "" }) =>
                `item/getAllItems?offset=${offset}&limit=${limit}&search=${search}`,
            providesTags: ["ItemCategory"],
        }),

        deleteItemCategory: builder.mutation({
            query: (id) => ({
                url: `item/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["ItemCategory"],
        }),

        getAllItemCategoriesIds: builder.query({
            query: () => "item/getAllItems",
            providesTags: ["ItemCategory"],
        }),

        getItemsByStoreIds: builder.query({
            query: ({ storeId, offset = 0, limit = 10, search = "" }) => ({
                url: `item/get/${storeId}`,
                params: { offset, limit, search },
            }),
            providesTags: ["ItemCategory"],
        }),

        sendItemCategoryIds: builder.mutation({
            query: (body) => ({
                url: "item/selectItems",
                method: "POST",
                body,
            }),
            invalidatesTags: ["ItemCategory"],
        }),
        removeItemCategory: builder.mutation({
            query: (itemId) => ({
                url: `item/removeCategory/${itemId}`,
                method: "DELETE",
            }),
            invalidatesTags: ["ItemCategory"],
        }),
        sendOtpLogin: builder.mutation({
            query: (body) => ({
                url: "user/sendOtp",
                method: "POST",
                body,
            }),
        }),

        verifyOtpLogin: builder.mutation({
            query: (body) => ({
                url: "user/verifyOtp",
                method: "POST",
                body,
            }),
        }),

        resetPasswordSendOtp: builder.mutation({
            query: (body) => ({
                url: "user/reset-otp",
                method: "POST",
                body,
            }),
        }),

        resetPasswordUsingOtp: builder.mutation({
            query: (body) => ({
                url: "user/reset-password-otp",
                method: "POST",
                body,
            }),
        }),

        createEnquiryIssue: builder.mutation({
            query: (body) => ({
                url: "/enquiryIssue/create",
                method: "POST",
                body,
            }),
            invalidatesTags: ["EnquiryIssue"],
        }),
        getEnquiryIssues: builder.query({
            query: () => ({
                url: "/enquiryIssue/get",
                method: "GET",
                headers: {
                    Authorization: JSON.parse(localStorage.getItem("token")),
                },
            }),
            providesTags: ["EnquiryIssue"],
        }),


        deleteEnquiryIssue: builder.mutation({
            query: (id) => ({
                url: `/enquiryIssue/delete/${id}`,
                method: "DELETE",
                headers: {
                    Authorization: JSON.parse(localStorage.getItem("token")),
                },
            }),
            invalidatesTags: ["EnquiryIssue"],
        }),
        updateEnquiryIssue: builder.mutation({
            query: ({ id, body }) => ({
                url: `enquiryIssue/update/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["EnquiryIssue"],
        }),

        getEnquiryUsers: builder.query({
            query: () => ({
                url: "/enquiry/getUsers",
                method: "GET",
            }),
            providesTags: ["EnquiryUsers"],
        }),

        createEnquiry: builder.mutation({
            query: (payload) => ({
                url: "/enquiry/create",
                method: "POST",
                body: payload,
            }),
            invalidatesTags: ["EnquiryIssue"],
        }),
        // getEnquiriesAdmin: builder.query({
        //     query: ({ offset = 1, limit = 10 }) => ({
        //         url: `/enquiry/get?offset=${offset}&limit=${limit}`,
        //         method: "GET",
        //     }),
        //     providesTags: ["EnquiryIssue"],
        // }),

        getEnquiriesAdmin: builder.query({
            query: ({ offset = 1, limit = 10, search = "" }) => ({
                url: `/enquiry/get?offset=${offset}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            providesTags: ["EnquiryIssue"],
        }),


        getEnquiries: builder.query({
            query: ({ userId, offset = 1, limit = 10 }) => ({
                url: `/enquiry/get?userId=${userId}&offset=${offset}&limit=${limit}`,
                method: "GET",
            }),
            providesTags: ["EnquiryIssue"],
        }),



        getEnquiryResponses: builder.query({
            query: ({ enquiryId, offset = 1, limit = 10 }) => ({
                url: `enquiry/getResponse/${enquiryId}?offset=${offset}&limit=${limit}`,
                method: "GET",
            }),
            providesTags: ["EnquiryIssueAdmin"],
        }),
        // CREATE
        createEnquiryResponse: builder.mutation({
            query: (body) => ({
                url: "enquiry/createResponse",
                method: "POST",
                body,
            }),
            invalidatesTags: ["EnquiryIssueAdmin"],

        }),

        // UPDATE
        updateEnquiryResponse: builder.mutation({
            query: ({ id, body }) => ({
                url: `enquiry/updateResponse/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["EnquiryIssueAdmin"],

        }),

        // DELETE
        deleteEnquiryResponse: builder.mutation({
            query: (id) => ({
                url: `enquiry/deleteResponse/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["EnquiryIssueAdmin"],

        }),


        getPlans: builder.query({
            query: ({ offset = 1, limit = 10 }) =>
                `plan/get?offset=${offset}&limit=${limit}`,
            providesTags: ["Plans"],
        }),

        createPlan: builder.mutation({
            query: (body) => ({
                url: "plan/create",
                method: "POST",
                body,
            }),
            invalidatesTags: ["Plans"],
        }),

        updatePlan: builder.mutation({
            query: ({ id, body }) => ({
                url: `plan/update/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["Plans"],
        }),

        deletePlan: builder.mutation({
            query: (id) => ({
                url: `plan/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Plans"],
        }),

        getTempEmployees: builder.query({
            query: ({ offset, limit, search = "" }) =>
                `tempEmployee/get?offset=${offset}&limit=${limit}&search=${search}`,
            providesTags: ["TempEmployee"],
        }),

        createTempEmployee: builder.mutation({
            query: (body) => ({
                url: "tempEmployee/create",
                method: "POST",
                body,
            }),
            invalidatesTags: ["TempEmployee"],
        }),

        updateTempEmployee: builder.mutation({
            query: ({ id, body }) => ({
                url: `tempEmployee/update/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["TempEmployee"],
        }),

        deleteTempEmployee: builder.mutation({
            query: (id) => ({
                url: `tempEmployee/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["TempEmployee"],
        }),
        getTomorrowNeeds: builder.query({
            query: ({ offset = 1, limit = 10 }) =>
                `order/tomorrowNeeds?offset=${offset}&limit=${limit}`,
        }),

        getTempEmployeesDropdown: builder.query({
            query: (params) => ({
                url: '/tempEmployee/get',
                params,
            }),
        }),
        getTempEmployeeLedgerSummary: builder.query({
            query: ({ offset = 1, limit = 10 }) => ({
                url: `tempEmployeeLedger/getAllLedger?offset=${offset}&limit=${limit}`,
                method: "GET",
            }),
            providesTags: ["TempLedger"],
        }),

        getParticularTempEmployeeLedger: builder.query({
            query: ({ empId, offset = 1, limit = 10 }) => ({
                url: `tempEmployeeLedger/getParticular/${empId}?offset=${offset}&limit=${limit}`,
                method: "GET",
            }),
            providesTags: ["TempLedger"],
        }),

        settleTempEmployeeAmount: builder.mutation({
            query: ({ empId, body }) => ({
                url: `tempEmployeeLedger/settleAmount/${empId}`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["TempLedger"]
        }),

        getAssetSummary: builder.query({
            query: ({ search } = {}) => ({
                url: "asset/getAssetSummary",
                method: "GET",
                params: search ? { search } : {},
            }),
            providesTags: ["Asset"],
        }),

        getAssetDetails: builder.query({
            query: (userId) => ({
                url: `asset/getAssetDetails/${userId}`,
                method: "GET",
            }),
            providesTags: ["AssetDetails"],
        }),

        returnAsset: builder.mutation({
            query: ({ userId, data }) => ({
                url: `asset/returnAsset/${userId}`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Asset", "AssetDetails"],
        }),

        createRazorpayOrder: builder.mutation({
            query: (planId) => ({
                url: "payment/create-order",
                method: "POST",
                body: { planId },
            }),
            invalidatesTags: ["paymentHistory"],
        }),

        verifyRazorpayPayment: builder.mutation({
            query: (body) => ({
                url: "payment/verify",
                method: "POST",
                body,
            }),
            invalidatesTags: ["paymentHistory"],
        }),

        getPaymentHistory: builder.query({
            query: ({ userId, offset, limit }) => {
                const params = new URLSearchParams();
                if (offset !== undefined) params.append('offset', offset);
                if (limit !== undefined) params.append('limit', limit);
                return `payment/history?userId=${userId}&${params.toString()}`;
            },
            providesTags: ["paymentHistory"],
        }),

        // getAdminPaymentHistory: builder.query({
        //     query: ({ offset = 1, limit = 10, userId }) => ({
        //         url: `payment/userPaymentDetails`,
        //         method: "GET",
        //         params: { offset, limit, userId },
        //     }),
        //     providesTags: ["AdminPaymentHistory"],
        // }),

        // getAdminPaymentHistory: builder.query({
        //     query: ({ offset = 1, limit = 10 }) => ({
        //         url: `payment/userPaymentDetails`,
        //         method: "GET",
        //         params: { offset, limit }, // ✅ only these two
        //     }),
        //     providesTags: ["AdminPaymentHistory"],
        // }),

        getAdminPaymentHistory: builder.query({
            query: ({ offset = 1, limit = 10, search, fromDate, toDate }) => {

                const params = { offset, limit };

                if (search) params.search = search;
                if (fromDate) params.fromDate = fromDate;
                if (toDate) params.toDate = toDate;

                return {
                    url: `payment/userPaymentDetails`,
                    method: "GET",
                    params,
                };
            },
            providesTags: ["AdminPaymentHistory"],
        }),

        getNetProfit: builder.query({
            query: ({ month, year }) => {
                const params = new URLSearchParams();
                if (month) params.append("month", month);
                if (year) params.append("year", year);
                
                return {
                    url: `journal/netProfit?${params.toString()}`,
                    method: "GET"
                };
            },
            providesTags: ["NetProfit"],
        }),

        sendPaymentReminder: builder.mutation({
            query: (userId) => ({
                url: `payment/reminder/${userId}`,
                method: "POST",
            }),
        }),

        createAppHistory: builder.mutation({
            query: (data) => ({
                url: "appHistory/create",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["AppHistory"],
        }),

        getAppHistory: builder.query({
            query: ({ offset = 1, limit = 10 }) => ({
                url: "appHistory/get",
                method: "GET",
                params: { offset, limit },
            }),
            providesTags: ["AppHistory"],
        }),

        getQueries: builder.query({
            query: ({ offset = 1, limit = 10, search = "" }) => ({
                url: "dashboard/getQueries",
                method: "GET",
                params: { offset, limit, search },
            }),
            providesTags: ["EnquiryIssue"],
        }),

        updateQueryStatus: builder.mutation({
            query: ({ id, status }) => ({
                url: `dashboard/updateQueryStatus/${id}`,
                method: "PUT",
                body: { status },
            }),
            invalidatesTags: ["EnquiryIssue"],
        }),

    }),
})

export const {
    // admin
    useCreateUserMutation,
    useGetRoleQuery,
    useGetUserBasedRolesQuery,
    useUserRoleQuery,
    useGetPermissionQuery,
    useCreatepermissionMutation,
    useUpdatePermissionMutation,
    useDeletePermissionMutation,
    useCreateroleMutation,
    useDeleteRoleMutation,
    useUpdateUserMutation,
    useUpdateRoleMutation,
    useDeleteUserMutation,
    useUserTypeQuery,
    useForgotPasswordMutation,
    useCreateUserTypeMutation,
    useDeleteUserTypeMutation,
    useSendInviteMutation,
    useGetInvitesQuery,
    useGetMyInvitesQuery,
    useGetUserByIdQuery,
    useGetOrdersQuery,
    useGetMyVendorsQuery,
    useGetItemsByStoreQuery,
    useCreateOrderMutation,
    useGetOrderByIdQuery,
    useUpdateOrderMutation,
    useGetItemBagsQuery,
    useGetMyEmployeesQuery,
    useUpdateOrderItemMutation,
    useAddItemToOrderMutation,
    useGetMyOrdersQuery,
    useGetMyOrderByIdQuery,
    useUpdateOrderAdminMutation,
    useGetItemcatQuery,
    useGetMyInvoicesQuery,
    useGetMyInvoicesselfQuery,
    useGetLogisticsQuery,
    useCreateInvoiceMutation,
    useGetInvoiceByIdQuery,
    useGetMyInvoiceByIdQuery,
    useAssignInvoiceMutation,
    useCancelInvoiceMutation,
    useCancelInvoiceMyMutation,
    useUpdateInvoiceStatusByOwnerMutation,
    useUpdateLogisticStatusMutation,
    useUpdateInvoiceStatusByStoreMutation,
    useUpdateOrderStatusMutation,
    useLogoutUserMutation,
    useGetInventoryItemsQuery,
    useGetFarmersQuery,
    useCreateInventoryMutation,
    useUpdateItemPriceMutation,
    useGetOverallPricesQuery,
    useUpdateOverallPriceMutation,
    useGetOverallPricesDataQuery,
    useLazyGetBillingItemsQuery,
    useGetBillingCustomersQuery,
    useCreateBillingMutation,
    useMoveToBillingMutation,
    useGetReceivedBillsQuery,
    useGetSingleBillingQuery,
    useLazyGetItemInfoQuery,
    useUpdateBillingItemMutation,
    useUpdateOverallBillMutation,
    useGetPayableBillsQuery,
    useGetPayableBillQuery,
    useCalculatePayableBillMutation,
    useGetMyBillsQuery,
    useGetMyBillViewQuery,
    useFarmerGetMyBillsQuery,
    useFarmerGetMyBillViewQuery,
    useGetNotificationsQuery,
    useGetNotificationsHeaderQuery,
    useGetUnreadCountQuery,
    useGetReportsQuery,
    useGetReportsLedgerQuery,
    useSendCreditsmsMutation,
    useCreateLedgerEntryMutation,
    useGetCustomerJournalsQuery,
    useGetReportByIdQuery,
    useGetPayableLedgerQuery,
    useGetPayableCustomerJournalsQuery,
    useCreatePayableLedgerEntryMutation,
    useGetDashboardQuery,
    useGetNetProfitQuery,
    useGetExpensesQuery,
    useDeleteExpenseMutation,
    useLazyGetBillPdfQuery,
    useLazyGetBillPdfPayableQuery,
    useLazyGetreportBillQuery,
    useVieGetMyInvoicesselfQuery,
    useLazyGetOrderPdfQuery,
    useLazyGetinvoicePdfQuery,
    useUpdateInventoryStockMutation,
    useAcceptInviteMutation,
    useSendEnquiryMutation,
    useSendItemCategoryMutation,
    useGetAllItemCategoriesQuery,
    useDeleteItemCategoryMutation,
    useGetAllItemCategoriesIdsQuery,
    useGetItemsByStoreIdsQuery,
    useSendItemCategoryIdsMutation,
    useRemoveItemCategoryMutation,
    useSendOtpLoginMutation,
    useVerifyOtpLoginMutation,
    useResetPasswordSendOtpMutation,
    useResetPasswordUsingOtpMutation,
    useCreateEnquiryIssueMutation,
    useGetEnquiryIssuesQuery,
    useDeleteEnquiryIssueMutation,
    useUpdateEnquiryIssueMutation,
    useCreateEnquiryMutation,
    useGetEnquiriesQuery,
    useGetEnquiriesAdminQuery,
    useGetEnquiryResponsesQuery,
    useCreateEnquiryResponseMutation,
    useUpdateEnquiryResponseMutation,
    useDeleteEnquiryResponseMutation,
    useGetEnquiryUsersQuery,
    useGetPlansQuery,
    useCreatePlanMutation,
    useUpdatePlanMutation,
    useDeletePlanMutation,
    useGetTempEmployeesQuery,
    useCreateTempEmployeeMutation,
    useUpdateTempEmployeeMutation,
    useDeleteTempEmployeeMutation,
    useGetTomorrowNeedsQuery,
    useGetTempEmployeesDropdownQuery,
    useGetTempEmployeeLedgerSummaryQuery,
    useGetParticularTempEmployeeLedgerQuery,
    useSettleTempEmployeeAmountMutation,
    useGetAssetSummaryQuery,
    useGetAssetDetailsQuery,
    useReturnAssetMutation,
    useCreateRazorpayOrderMutation,
    useVerifyRazorpayPaymentMutation,
    useGetPaymentHistoryQuery,
    useGetAdminPaymentHistoryQuery,
    useSendPaymentReminderMutation,
    useAcceptInviteFromMutation,
    useCreateAppHistoryMutation,
    useGetAppHistoryQuery,
    useGetDashboardQueriesQuery,
    useUpdateDashboardQueryStatusMutation,
} = adminApi